interface NFTotemLogoProps {
  className?: string
  width?: number
  height?: number
  color?: string
}

export function NFTotemLogo({ className = "", width = 132, height = 32, color = "#7B39ED" }: NFTotemLogoProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 132 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.0211 25.007H17.9427V7.45703H14.4327V19.8937H14.3461L5.0944 7.45703H1.30273V25.007H4.81273V12.8304H4.8994L14.0211 25.007Z"
        fill={color}
      />
      <path
        d="M24.2359 25.007H20.5742V7.45703H48.0597V10.6637H42.3614V25.007H38.7647V10.6637H24.2359V14.5637H32.4259V17.7704H24.2359V25.007Z"
        fill={color}
      />
      <path d="M85.2179 25.007H88.8145V10.6637H94.5129V7.45703H79.5195V10.6637H85.2179V25.007Z" fill={color} />
      <path
        d="M108.627 25.007H95.8223V7.45703H108.627V10.6637H99.4839V14.347H107.912V17.467H99.4839V21.8004H108.627V25.007Z"
        fill={color}
      />
      <path
        d="M110.525 25.007V7.45703H115.53L120.73 19.8287H120.817L125.995 7.45703H130.979V25.007H127.317V12.6137H127.23L122.204 25.007H119.062L114.057 12.6137H113.97V25.007H110.525Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.9992 0.640625L77.1928 8.32676V23.6718L63.9983 31.3579L50.8047 23.6717V8.32673L63.9992 0.640625ZM54.3047 10.3384V21.6601L63.9984 27.3073L73.6928 21.6601V10.3384L63.9991 4.6912L54.3047 10.3384Z"
        fill={color}
      />
    </svg>
  )
}
